import React, { FC } from 'react';
import { Spin } from 'antd';

type Props = {
  fullscreen?: boolean;
};
export const Loading: FC<Props> = ({ fullscreen }) => {
  return <Spin fullscreen={fullscreen} />;
};

export default Loading;
